import { render } from "./WorkExperience.vue?vue&type=template&id=2c097c09&ts=true"
import script from "./WorkExperience.vue?vue&type=script&lang=ts"
export * from "./WorkExperience.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__